export const industryOptions = [
  { label: 'Logistics', value: 'LOGISTICS' },
  { label: 'SaaS/Enterprise', value: 'SAAS_ENTERPRISE' },
  { label: 'Fintech', value: 'FINANCIAL_SERVICES_FINTECH' },
  { label: 'Gaming', value: 'GAMING' },
  { label: 'RetailTech', value: 'RETAILTECH' },
  { label: 'HealthTech', value: 'HEALTHTECH' },
  { label: 'Consumer Brand', value: 'CONSUMER_BRANDS' },
  { label: 'Services', value: 'SERVICES' },
  { label: 'EdTech', value: 'EDTECH' },
  { label: 'Social/Entertainment', value: 'SOCIAL_ENTERTAINMENT' },
  { label: 'AgriTech', value: 'AGRITECH' },
  { label: 'Travel & Hospitality', value: 'TRAVEL_AND_HOSPITALITY' },
  { label: 'AI', value: 'AI' },
  { label: 'EV/Mobility', value: 'EV_MOBILITY' },
  { label: 'E-Commerce', value: 'ECOMMERCE' },
  { label: 'DeepTech', value: 'DEEPTECH' },
  { label: 'PropTech', value: 'PROPTECH' },
  { label: 'Marketplace/Platform', value: 'MARKETPLACE_PLATFORM' },
  { label: 'CleanTech', value: 'CLEANTECH' },
  { label: 'F&B', value: 'F_AND_B' },
  { label: 'Other', value: 'OTHER' },
];

const constants = {
  // Platform default setup fee, as a percentage. Deals may override it.
  DEFAULT_SETUP_FEE_PERCENTAGE: 2.5,
  TEXT_EDITOR_VERSION: '2.28.2',
  ALT_AVATAR_URL:
    'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80',
};

export default constants;
